import { render, staticRenderFns } from "./setLimitDialog.vue?vue&type=template&id=1f8dc480&scoped=true"
import script from "./setLimitDialog.vue?vue&type=script&lang=js"
export * from "./setLimitDialog.vue?vue&type=script&lang=js"
import style0 from "./setLimitDialog.vue?vue&type=style&index=0&id=1f8dc480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dc480",
  null
  
)

export default component.exports